<template>
	<ReservationsTimeline v-if="roomsOrdersStore.reservationsViewMode === 'timeline'" v-bind="$attrs" />
	<ReservationView v-else v-bind="$attrs" />
</template>

<script>
import {useRoomsOrdersStore} from "@/console-new/stores";
import ReservationView from "@/console-new/components/ops/tables/ReservationView.vue";
import ReservationsTimeline from "@/console-new/components/ops/tables/ReservationsTimeline.vue";

export default {
	name: "OpsReservationsContainer",
	inheritAttrs: false,
	components: {ReservationView, ReservationsTimeline},
	setup() {
		const roomsOrdersStore = useRoomsOrdersStore();
		return {roomsOrdersStore};
	},
};
</script>
